/**
 * Central registry for home/landing imagery.
 * Assets provided by the design team live in public/images/homepage/redesign.
 * A few slots are still pending from design and fall back to placeholders.
 */
export const homeAssets = {
  heroDark: require('../../../public/images/homepage/bg-dark.png'),
  heroLight: require('../../../public/images/homepage/bg-light.png'),
  pickModelS: require('../../../public/images/homepage/redesign/pick-model-s.png'),
  pickCybertruck: require('../../../public/images/homepage/redesign/pick-cybertruck.png'),
  pickRivian: require('../../../public/images/homepage/redesign/pick-rivian.png'),
  feature01: require('../../../public/images/homepage/redesign/feature-01.png'),
  feature01Mobile: require('../../../public/images/homepage/redesign/feature-mobile-01.png'),
  feature02: require('../../../public/images/homepage/redesign/feature-02.png'),
  feature02Mobile: require('../../../public/images/homepage/redesign/feature-mobile-02.png'),
  feature03: require('../../../public/images/homepage/redesign/feature-03.png'),
  feature03Mobile: require('../../../public/images/homepage/redesign/feature-mobile-03.png'),
  subscription: require('../../../public/images/homepage/redesign/subscription.png'),
  subscriptionMobile: require('../../../public/images/homepage/redesign/subscription-mobile.png'),
  partner: require('../../../public/images/homepage/redesign/partner.png'),
  partnerMobile: require('../../../public/images/homepage/redesign/partner-mobile.png'),
  getAppBackgroundDark: require('../../../public/images/homepage/redesign/get-app-background-dark.png'),
  getAppBackgroundLight: require('../../../public/images/homepage/redesign/get-app-background-light.png'),
  downloadAppStore: require('../../../public/images/app-icons/download-app-store.webp'),
  downloadGooglePlay: require('../../../public/images/app-icons/download-google-play.webp'),
};

export const locationAssets = {
  newYork: require('../../../public/images/homepage/new-york.png'),
  sanFrancisco: require('../../../public/images/homepage/san-francisco.png'),
  austin: require('../../../public/images/homepage/austin.png'),
  miami: require('../../../public/images/homepage/miami.png'),
  losAngeles: require('../../../public/images/homepage/los-angeles.png'),
  atlanta: require('../../../public/images/homepage/atlanta.png'),
};
